import * as React from "preact";
import { FunctionComponent } from "preact";
import { useState } from "preact/hooks";
import SVGIcon from "../SVGIcon";
import cx from "classnames";

import { ITableColumns } from "../Table";

interface ITableHead {
  columns: ITableColumns[];
  handleSorting;
  currentFilter;
}

const TableHead: FunctionComponent<ITableHead> = ({ columns, handleSorting, currentFilter }) => {
  const [sortField, setSortField] = useState("aerRate");
  const [order, setOrder] = useState("desc");

  const handleSortingChange = (accessor) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  };

  const getSortIcon = (isSorted: boolean) => {
    if (!isSorted) return "default";
    if (order ==="asc") return "down";
    if (order === "desc") return "up";

    return "default";
  }

  return (
    <thead className="table__head">
      <tr>
        {columns.map(({ label, accessor, hiddenOn, shownOn }) => {
          const isSorted = sortField === accessor;
          const isHidden = currentFilter == hiddenOn || (shownOn != null && currentFilter != shownOn);
          const icon = getSortIcon(isSorted);

          if (isHidden) return;

          return (
            <th
              key={accessor}
              className="table-label"
              onClick={() => handleSortingChange(accessor)}
            >
              <div className="table__head--cell">
                <div className="table__head--title">{label}</div>
                <div className="table__head--icons">
                  <SVGIcon
                    name={`chevron--up`}
                    className={cx("chevron-icon", `chevron-icon--up`, "icon--xs", {
                      invisible: isSorted && icon === "up",
                    })}
                  />
                  <SVGIcon
                    name={`chevron--down`}
                    className={cx("chevron-icon", `chevron-icon--down`, "icon--xs", {
                      invisible: isSorted && icon === "down",
                    })}
                  />
                </div>
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHead;
